import React from 'react';
import ReactDOM from 'react-dom/client';
import './css/style.css';
import './css/intro.css';
import './css/animations.css';
import './css/readability.css';
import './css/terminal-modal.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
